import { Currencies } from "@orbital/games-frontend-library"
import React, { useEffect, useRef } from "react"
import typeOfJackpots from "../grid/data"

import { CollectWrapper, CollectBtn, Cube, Title } from "./CollectStyles"

export default function Collect({
  data,
  handleJackpotPopup,
  setIsJackpot,
}: any) {
  const cube =
    data.wintype == 1 ? "solar" : data.wintype == 2 ? "galactical" : "stellar"

  const result = typeOfJackpots.find((obj) => {
    return obj.text === cube
  })

  const handleEndJackpot = () => {
    handleJackpotPopup(false)
    setIsJackpot(false)
    //send msg
  }
  return (
    <CollectWrapper>
      <Title color={cube}>
        <h2>{cube} wins</h2>
        <p>
          {Currencies[data.currency]}
          {data.winamount}
        </p>
      </Title>
      {result && (
        <Cube
          color={result.color}
          shadow={result.shadow}
          background={result.background}
        >
          <img src={result.svg} />
        </Cube>
      )}
      <CollectBtn color={cube} onClick={() => handleEndJackpot()}>
        Collect
      </CollectBtn>
    </CollectWrapper>
  )
}
